import React from 'react';
import LogoType from '../../../../../../styles/images/menigo_redwhitegrey_tagline.svg';
import LogoTypeMobile from '../../../../../../styles/images/menigo_redwhite_notagline.svg';
import * as styles from './LogoType.scss';
import { SMALL } from 'Shared/breakpoints';
import classnames from 'classnames';
export default (props) => {
    const isMobile = (currentBreakpoint) => currentBreakpoint <= SMALL;
    const logoClassName = classnames(styles.logotype, props.className || '');
    return !props.disableLink ? (React.createElement("div", { className: classnames(styles.logotypeWrapper, { [styles.small]: !!props.small }) },
        React.createElement("a", { className: logoClassName, href: props.siteUrl },
            isMobile(props.breakpoints) || !!props.small ? React.createElement(LogoTypeMobile, null) : React.createElement(LogoType, null),
            React.createElement("span", { className: styles.visuallyHidden }, "Menigo")))) : (React.createElement("div", { className: styles.logotypeWrapper }, isMobile(props.breakpoints) || !!props.small ?
        React.createElement(LogoTypeMobile, { className: logoClassName }) :
        React.createElement(LogoType, { className: logoClassName })));
};
